
/**@param {Object} options*/
export function ChiliCommentsYandexCaptcha (options){

    if(!new.target){
        return new ChiliCommentsYandexCaptcha(options);
    }

    this.options = options;

    this.options.invisible = this.options.invisible || false;

    this.widgetId = null;

    let captchaSolved = false;

    let eventListeners = {};

    this.addEventListener = (event, listener) => {

        if (!eventListeners[event]) {
            eventListeners[event] = [];
        }

        eventListeners[event].push(listener);
    }

    this.emit = (event, data)  => {
        if (eventListeners[event]) {
            eventListeners[event].forEach((listener) => {
                if(typeof listener === "function"){
                    listener(data)
                }
            });
        }
    }

    /**@param {HTMLElement} form*/
    this.render = (form) => {

        if (!window.smartCaptcha) {
            return;
        }

        let captchaContainer = form.querySelector('.captcha-container');

        if(this.widgetId !== null){
            window.smartCaptcha.reset(this.widgetId);
        }
        else{
            this.widgetId = window.smartCaptcha.render(captchaContainer, {
                sitekey: this.options.publicKey,
                invisible: this.options.invisible,
                test: false,
            });

            window.smartCaptcha.subscribe(this.widgetId, 'success', ()=>{
                this.emit('captcha-success', {form: form});

                if(this.isDependedCaptcha()){
                    this.render(form);
                }
            });

            window.smartCaptcha.subscribe(this.widgetId, 'token-expired', ()=>{
                this.emit('captcha-expired', {form: form});
                this.render(form);
            })

        }
    };

    /**@param {HTMLElement} form*/
    this.check = (form) => {

        // Мы можем принудительно вызвать проверку только для невидимой капчи

        if (!window.smartCaptcha) {
            console.error('There are no Yandex smartcaptcha library');
            return;
        }

        if(this.widgetId !== null){
            if(this.options.invisible){
                return window.smartCaptcha.execute(this.widgetId);
            }
        }
        else{
            console.error('Widget ID not set');
        }
    }

    this.setPublicKey = (publicKey) => {
        this.options.publicKey = publicKey;
    }

    this.isDependedCaptcha = () => {
        return this.options.invisible;
    }


    return this;

}
